<div class="archived-container">
  <app-search-guides #searchGuides
                     class="block mt-48px"
                     [associatedInsiderId]="associatedInsiderId"
                     [status]="types.GuideStatus.Archived"></app-search-guides>
</div>
